import { api } from "../api";
import { GetUserInfoResponse, OnboardingPayload } from "./interface";
export { editPersonalData, saveLanguagePreference } from "./edit";

export async function getUserInfo(): Promise<GetUserInfoResponse> {
  const res = await api.get<GetUserInfoResponse>("/me");
  return res.data;
}

/**
 * Отправить онбординг-форму. После успешного ответа `/me` начнёт
 * возвращать `is_onboarded: true` — гейт пустит в основной UI.
 */
export async function submitOnboarding(
  payload: OnboardingPayload,
): Promise<GetUserInfoResponse> {
  const res = await api.post<GetUserInfoResponse>("/me/onboarding", payload);
  return res.data;
}

/**
 * Проверить PIN-код на «lock-screen» приложения.
 * Возвращает `true` при совпадении, `false` иначе.
 *
 * Бэк отвечает 204 при успехе и 401 при неверном PIN'e — мы
 * трактуем любую другую ошибку как «не смогли проверить» → возвращаем
 * false, чтобы юзер увидел шейк и мог повторить.
 */
export async function verifyPin(pin: string): Promise<boolean> {
  try {
    await api.post("/me/pin/verify", { pin });
    return true;
  } catch {
    return false;
  }
}

export async function updateAvatar(
  avatarUrl: string | null,
): Promise<GetUserInfoResponse> {
  const res = await api.patch<GetUserInfoResponse>("/me/avatar", { avatarUrl });
  return res.data;
}

export async function regenerateAvatar(): Promise<GetUserInfoResponse> {
  const res = await api.post<GetUserInfoResponse>("/me/avatar/regenerate");
  return res.data;
}
